import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import ItemDataEntryPopup from "../../../../../im/codes/itemDataEntry/common/ItemDataEntryPopup";
import { Button } from 'devextreme-react/button';
const basisType = [
    { ID: 'A', Text: 'Average Cost' },
    { ID: 'L', Text: 'Last Cost' }
]
const statusType = [
    { ID: 'A', Text: 'Active' },
    { ID: 'I', Text: 'InActive' }
]
const taxStatus = [
    { ID: 'Y', Text: 'Yes' },
    { ID: 'N', Text: 'No' }
]
const ItemMasterResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "93464550-cdc7-4251-b598-179da9de57cb";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
       const [showPopup, setShowPopup] = useState({id:null,visible:false});
        const onSelectionChanged =({selectedRowsData}) => {
            const selectedRowData = selectedRowsData[0];
            setShowPopup({id:selectedRowData.rowid,visible:false});
        };
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}>
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="warehouseID" caption='Warehouse' ></Column>
                <Column dataField="itemCode" caption='Item' ></Column>
                <Column dataField="description_1" caption='Item Description -1' ></Column>
                <Column dataField="description_2" caption='Item Description -2' ></Column>
                <Column dataField="classCode" caption='Class' ></Column>
                <Column dataField="subClassCode" caption='Sub Class' ></Column>
                <Column dataField="netAvailable" format={{
                    type: 'fixedPoint',
                    precision: 2
                }} caption='Net Available' ></Column>
                <Column dataField="averageCost" caption="Average Cost" format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'USD',
                    useGrouping: true
                }} visible={false}> </Column>

                <Column dataField="available" caption="Available" visible={false} format={{
                    type: 'fixedPoint',
                    precision: 2
                }}></Column>
                <Column dataField="availableDate" caption="Available Dt" dataType="date" visible={false}></Column>
                <Column dataField="costBasis" caption="Cost Basis" visible={false}
                    lookup={{ dataSource: basisType, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'A':
                                return <span>Average Cost</span>;
                            case 'L':
                                return <span>Last Cost</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}
                ></Column>
                <Column dataField="unitValue" caption="Unit Value" visible={false}></Column>
                <Column dataField="unitValueuom" caption="Unit Value UOM" visible={false}></Column>
                <Column dataField="unitVolumeuom" caption="Unit Volume UOM" visible={false}></Column>
                <Column dataField="unitPckg" caption="Unit/Pkg" visible={false}></Column>
                <Column dataField="unitPkguom" caption="Unit/Pkg UOM" visible={false}></Column>

                <Column dataField="unavailable" caption="Unavailable" visible={false} format={{
                    type: 'fixedPoint',
                    precision: 2
                }}></Column>
                <Column dataField="taxstatus" caption="Tax Status" visible={false}
                    lookup={{ dataSource: taxStatus, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'Y':
                                return <span>Yes</span>;
                            case 'N':
                                return <span>No</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}></Column>
                <Column dataField="standardcost" caption="Standard Cost" visible={false}></Column>
                <Column dataField="salemaxquantity" caption="Sale Max Qty" visible={false}></Column>
                <Column dataField="stackheight" caption="Stack Height" visible={false}></Column>
                <Column dataField="reorderMaxQty" caption="Reorder Max Qty" visible={false}></Column>
                <Column dataField="reorderMinQty" caption="Reorder Min Qty" visible={false}></Column>
                <Column dataField="reorderMaxDay" caption="Reorder Max Day" visible={false}></Column>
                <Column dataField="reorderMinDay" caption="Reorder Min Day" visible={false}></Column>
                <Column dataField="reorderCalQty" caption="Reorder Cal Qty" visible={false}></Column>
                <Column dataField="artradediscountflag" caption="AR Trade Disc" visible={false}></Column>
                <Column dataField="artermsdiscountflag" caption="AR Terms Disc" visible={false}></Column>
                <Column dataField="bomExplosionFlag " caption="Bom Explosion Flag" visible={false}></Column>
                <Column dataField="dateExpiration " caption="Date Expiration" dataType="date" visible={false}></Column>
                <Column dataField="careInstructions " caption="Care Instructions" visible={false}></Column>
                <Column dataField="dateIntroduced" caption="Date Introduced" dataType="date" visible={false}></Column>
                <Column dataField="inventoryUnitUom " caption="Inventory Unit Uom" visible={false}></Column>
                <Column dataField="itemSourceFlag" caption="ItemSourceFlag" visible={false}> </Column>
                <Column dataField="locationmaxunitsforwardpick " caption="Max Units Fwd Pick" visible={false}></Column>
                <Column dataField="locationmaxunitsreplenishment " caption="Max Units Repl" visible={false}></Column>
                <Column dataField="minimumsalesquantity " caption="Min Sales Qty" visible={false}></Column>
                <Column dataField="locationminunitsforwardpick " caption="Min Units Fwd Pick" visible={false}></Column>
                <Column dataField="locationminunitsreplenishment " caption="Min Units Repl" visible={false}></Column>
                <Column dataField="wearHouseName " caption="WearHouse Name" visible={false}></Column>
                <Column dataField="userdefinedcode1" caption="User Defined Code 1" visible={false} />
                <Column dataField="userdefinedcode2" caption="User Defined Code 2" visible={false} />
                <Column dataField="userdefinedcode3" caption="User Defined Code 3" visible={false} />
                <Column dataField="userdefinedcode4" caption="User Defined Code 4" visible={false} />
                <Column dataField="userdefinedcode5" caption="User Defined Code 5" visible={false} />
                <Column dataField="userdefinedcode6" caption="User Defined Code 6" visible={false} />
                <Column dataField="userdefinedcode7" caption="User Defined Code 7" visible={false} />
                <Column dataField="userdefinedcode8" caption="User Defined Code 8" visible={false} />
                <Column dataField="userdefinedcode9" caption="User Defined Code 9" visible={false} />
                <Column dataField="userdefinedcode10" caption="User Defined Code 10" visible={false} />
                <Column dataField="creationuserid" caption="Creation User ID" visible={false} />
                <Column dataField="creationdatetime" caption="Creation Date Time" visible={false} />
                <Column dataField="lastupdatedatetime" caption="Last Update Date Time" visible={false} />
                <Column dataField="userdefineddate1" caption="User Defined Date 1" visible={false} />
                <Column dataField="userdefineddate2" caption="User Defined Date 2" visible={false} />
                <Column dataField="userdefineddate3" caption="User Defined Date 3" visible={false} />
                <Column dataField="userdefineddate4" caption="User Defined Date 4" visible={false} />
                <Column dataField="userdefineddate5" caption="User Defined Date 5" visible={false} />
                <Column dataField="userdefineddate6" caption="User Defined Date 6" visible={false} />
                <Column dataField="userdefineddate7" caption="User Defined Date 7" visible={false} />
                <Column dataField="userdefineddate8" caption="User Defined Date 8" visible={false} />
                <Column dataField="userdefineddate9" caption="User Defined Date 9" visible={false} />
                <Column dataField="userdefineddate10" caption="User Defined Date 10" visible={false} />
                <Column dataField="inreceiving" caption="In Receiving" visible={false} />
                <Column dataField="itemcode" caption="Item Type" visible={false} />
                <Column dataField="subclasscode" caption="Last Cost" visible={false} />
                <Column dataField="lastupdateuserid" caption="Last Update User ID" visible={false} />
                <Column dataField="pricelevela" caption="Price Level A" visible={false} />
                <Column dataField="pricelevelb" caption="Price Level B" visible={false} />
                <Column dataField="pricelevelc" caption="Price Level C" visible={false} />
                <Column dataField="priceleveld" caption="Price Level D" visible={false} />
                <Column dataField="pricelevele" caption="Price Level E" visible={false} />
                <Column dataField="status" caption="Status" visible={false}
                    lookup={{ dataSource: statusType, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'A':
                                return <span>Active</span>;
                            case 'I':
                                return <span>InActive</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }} />
                <Column dataField="userdefinedquantity1" caption="User Defined Quantity 1" visible={false} />
                <Column dataField="userdefinedquantity2" caption="User Defined Quantity 2" visible={false} />
                <Column dataField="userdefinedquantity3" caption="User Defined Quantity 3" visible={false} />
                <Column dataField="userdefinedquantity4" caption="User Defined Quantity 4" visible={false} />
                <Column dataField="userdefinedquantity5" caption="User Defined Quantity 5" visible={false} />
                <Column dataField="userdefinedquantity6" caption="User Defined Quantity 6" visible={false} />
                <Column dataField="userdefinedquantity7" caption="User Defined Quantity 7" visible={false} />
                <Column dataField="userdefinedquantity8" caption="User Defined Quantity 8" visible={false} />
                <Column dataField="userdefinedquantity9" caption="User Defined Quantity 9" visible={false} />
                <Column dataField="userdefinedquantity10" caption="User Defined Quantity 10" visible={false} />
                <Column dataField="userdefinedreference1" caption="User Defined Reference 1" visible={false} />
                <Column dataField="userdefinedreference2" caption="User Defined Reference 2" visible={false} />
                <Column dataField="userdefinedreference3" caption="User Defined Reference 3" visible={false} />
                <Toolbar>
                 <Item location="before">
                     <Button text="Edit" disabled={!showPopup.id} type="default" onClick={()=>setShowPopup(prevFormData=>({...prevFormData, visible:true}))} />
                 </Item>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                 </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <ItemDataEntryPopup showPopup={showPopup} setShowPopup={setShowPopup}/>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemMasterResult);